export type BatchMethod = "EIP-5792" | "EIP-7702";

export const BATCH_METHOD_EIP5792 = "EIP-5792" as const satisfies BatchMethod;
export const BATCH_METHOD_EIP7702 = "EIP-7702" as const satisfies BatchMethod;

export function parseBatchMethod(value: string): BatchMethod {
  const n = value.trim().toLowerCase().replace(/-/g, "");
  if (n === "eip5792") return BATCH_METHOD_EIP5792;
  if (n === "eip7702") return BATCH_METHOD_EIP7702;
  throw new Error(`Invalid batch method: ${value}`);
}

export function tryParseBatchMethod(value: string): BatchMethod | null {
  try {
    return parseBatchMethod(value);
  } catch {
    return null;
  }
}
